import React, { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useLocation } from 'react-router-dom';
import { getParamsFromSearch } from 'core/utils/helpers/getParamsFromSearch';
import { useGetAllInstoreOffers } from 'core/modules/Instore2/hooks/useGetInstoreOffers';
import Portal from 'core/modules/Portal/Portal';
import MeInstoreOnlyOffer from 'core/modules/Instore2/components/MePage/MeInstoreOnlyOffer/MeInstoreOnlyOffer';
import MeInstoreOffer from 'core/modules/Instore2/components/MePage/MeInstoreOffer/MeInstoreOffer';
import FeaturedInstoreOffers from 'core/modules/Instore2/components/FeaturedInstoreOffers/FeaturedInstoreOffers';

import './MerchantExperienceContent.scss';

function MerchantExperience() {
  const location = useLocation();
  const { gmid } = getParamsFromSearch(location.search);
  const { offers, isLoaded } = useGetAllInstoreOffers();

  const offer = offers.find(({ carteraMerchantId }) => carteraMerchantId === Number(gmid));

  const checkIsDeactivatedMerchant = () => {
    const merchant = window.mn.meData?.response?.[0];
    return !merchant || merchant.type === 'Deactivated Merchant' || merchant.type === 'Suspended Merchant';
  };

  // Remove `mn_hidden` class and show the default CanJs content if there are no
  // associated in-store offer to the current Deactivated or Suspended merchants
  const showInitialBodyContent = () => {
    const maxAttempts = 15;
    const intervalDuration = 300;
    let attempts = 0;

    const intervalId = setInterval(() => {
      const element = document.querySelector('#mn_me .mn_bodyContent.mn_hidden');

      if (element) {
        element.classList.remove('mn_hidden');
        clearInterval(intervalId);
      }

      if (attempts > maxAttempts) {
        clearInterval(intervalId);
      }

      attempts += 1;
    }, intervalDuration);

    return intervalId;
  };

  useEffect(() => {
    if (isLoaded && isEmpty(offer)) {
      const intervalId = showInitialBodyContent();
      return () => { clearInterval(intervalId); };
    }

    return () => {};
  }, [isLoaded, offer]);

  const isDeactivatedMerchant = checkIsDeactivatedMerchant();

  if (isEmpty(offer)) {
    return null;
  }

  if (isDeactivatedMerchant) {
    return (
      <Portal selector=".mn_instoreOnlyPlaceholder" time={8000}>
        <MeInstoreOnlyOffer offer={offer} />
        <FeaturedInstoreOffers />
      </Portal>
    );
  }

  return (
    <Portal selector=".mn_instoreOfferPlaceholder" time={8000}>
      <MeInstoreOffer offer={offer} />
    </Portal>
  );
}

export default MerchantExperience;
